import * as React from 'react';
import {Icon, Menu} from "semantic-ui-react";
import NavLink from "../containers/NavLink";
import {
	ROUTE_ACCESS, ROUTE_GENERAL,
	ROUTE_HOUSE,
	ROUTE_KFZ,
	ROUTE_MODULES,
	ROUTE_PROFILE,
	ROUTE_ROOT,
	ROUTE_SERVICE,
	ROUTE_SIGN_OUT
} from "../routes";



export default () => (
	<Menu vertical inverted  className="ah-sidebar">
		<div id="nav-top">
			<Menu.Item name="home">
				<NavLink exact to={ROUTE_ROOT}>
					<Icon name="header"/>
					Home
				</NavLink>
			</Menu.Item>
			<Menu.Item>
				<NavLink exact to={ROUTE_GENERAL}>
					<Icon name={"toggle on"}/>
					Generell
				</NavLink>
			</Menu.Item>
			<Menu.Item name="access">
				<NavLink to={ROUTE_ACCESS}>
					<Icon name="universal access"/>
					Zugang
				</NavLink>
			</Menu.Item>
			<Menu.Item name="modules">
				<NavLink to={ROUTE_MODULES}>
					<Icon name="block layout"/>
					Module
				</NavLink>
			</Menu.Item>
			<Menu.Item name="houses">
				<NavLink to={ROUTE_HOUSE}>
					<Icon name="home"/>
					Häuser
				</NavLink>
			</Menu.Item>
			<Menu.Item name="servies">
				<NavLink to={ROUTE_SERVICE}>
					<Icon name="fork"/>
					Dienste
				</NavLink>
			</Menu.Item>
			<Menu.Item name="cars">
				<NavLink to={ROUTE_KFZ}>
					<Icon name="car"/>
					KFZ
				</NavLink>
			</Menu.Item>
		</div>
		<div id="nav-bottom">
			<Menu.Item name="profile">
				<NavLink to={ROUTE_PROFILE}>
					<Icon name="user" />
					Profil
				</NavLink>
			</Menu.Item>
			<Menu.Item>
				<NavLink to={ROUTE_SIGN_OUT}>
					<Icon name="sign out"/>
					Abmelden
				</NavLink>
			</Menu.Item>
		</div>
	</Menu>
);


// WEBPACK FOOTER //
// ./src/components/Navigation.js